module.exports = __webpack_public_path__ + "media/item_reveal4_mythical.05bbe491.wav";